export const TAB_INVALID_CONTACTS = 'invalid-contacts';
